<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-select-v2
                clearable
                class="qweelement"
                :options="options"
                v-if="isSelect"
                v-model="data[name]" 
                @visible-change="visibleChange"
                :filterable = "isFilterAble"
                :allow-create="isAddable"
                :disabled = "disabled"
                placeholder="请选择">
            </el-select-v2>

            <div v-if="!isSelect">
                <el-radio-group
                    style="width:100%" 
                    v-model="data[name]"
                    :disabled = "disabled">
                    <el-radio v-for="item in options"
                        :key="item.Value"
                        :label = "item.Value"
                        :value = "item.Value">
                        {{ item.Label }}
                    </el-radio>
                </el-radio-group>
            </div>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import baseChoiceProField from "./BaseChoiceProField" 
    export default{
        name:"SingleChoiceProField",
        mixins:[baseChoiceProField]
    }
</script>